module.exports = require('scryptsy');